export const getStringLength = (str) => {
    // taken from https://stackoverflow.com/a/54369605/4672339
    return Array.from(str).length;
};
//# sourceMappingURL=get_string_length.js.map